
import request from '@/service/request'

export const getCodeRecordPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<CODE.Detail[]>>({
    url: '/admin/code/page',
    method: 'GET',
    params
  })
}

export const verifyCode = (code: string) => {
  return request<SERVICE.ResponsePage<CODE.Detail[]>>({
    url: '/admin/code/' + code,
    method: 'GET'
  })
}
